import { Navigate, createFileRoute } from "@tanstack/react-router";

function OkrsIndexRouteView() {
  return <Navigate to="/okrs/org-chart" replace />;
}

export const Route = createFileRoute("/_app/okrs/")({
  component: OkrsIndexRouteView,
});
